import { render, staticRenderFns } from "./LightTable.vue?vue&type=template&id=30c26d8c&"
import script from "./LightTable.vue?vue&type=script&lang=js&"
export * from "./LightTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports